import { createClient } from '@supabase/supabase-js'
import { createLogger } from './debug'

const log = createLogger('supabase')

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

log.log('createClient url=', supabaseUrl ? `${supabaseUrl.slice(0, 30)}...` : '(empty)')

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
